import {LiveGameContainerDefaultBox} from "./live-game-container.default.box";

export const LiveGameContainerBox = LiveGameContainerDefaultBox;
